import { useTranslation } from "react-i18next"

import { Card, CardContent, Separator } from "@f2e/ui/components/base"

import { ErrorPage } from "@/components/System"
import { UserNameplate } from "@/components"
import { useStore } from "@/store"

import {
  DataItem,
  OrganizationAvatarUpload,
  OrganizationNameInput,
} from "../components"

const OrganizationGeneralTab = () => {
  const [currentOrganization] = useStore((state) => [state.currentOrganization])
  const { t } = useTranslation()

  if (!currentOrganization) {
    return <ErrorPage message={t("settings.users.errors.orgNotFound")} />
  }

  return (
    <div className="flex flex-col">
      <h3 className="text-2xl font-semibold leading-none tracking-tight">
        {t("settings.organization.title")}
      </h3>
      <p className="mt-2 mb-4 text-sm text-slate-500 dark:text-slate-400">
        {t("settings.organization.description")}
      </p>
      {currentOrganization && (
        <div className="overflow-hidden overflow-y-auto">
          <Card className="mt-4">
            <CardContent className="flex flex-col gap-2 p-4">
              <DataItem
                title={t("settings.organization.avatar")}
                editable={true}
                valueElement={
                  <OrganizationAvatarUpload
                    organization={currentOrganization}
                  />
                }
              />
              <Separator />
              <DataItem
                title={t("settings.organization.owner")}
                valueElement={
                  <UserNameplate
                    className="flex-row-reverse gap-2 text-end"
                    user={currentOrganization.owner}
                    size={10}
                  />
                }
              />
              <Separator />
              <DataItem
                title={t("settings.organization.name")}
                editable={true}
                valueElement={
                  <OrganizationNameInput organization={currentOrganization} />
                }
              />
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  )
}

export default OrganizationGeneralTab
